import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tooltip} from 'antd';

import {NavigationLink} from '../../../../layout/navigation-link/navigation-link';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {CalendarModerationEnum} from '../../../../service/publications/publications-calendar-type';
import {classNames} from '../../../../util/css';

import {
    ICON_BY_CALENDAR_MODERATION,
    ICON_BY_CALENDAR_PUBLICATION_TYPE,
    STATUS_MODIFIER_BY_CALENDAR_POST_STATUS,
    TEXT_BY_CALENDAR_MODERATION,
} from './posts-calendar-const';
import {getCalendarEntryLink} from './posts-calendar-helper';
import {PostInsideDayCardType} from './posts-calendar-type';
import * as styles from './posts-calendar.scss';

type PropsType = {
    entry: PostInsideDayCardType;
};

// One publication inside a day cell, rendered as a status-tinted pill. The name is the only element
// that flexes, which is what makes the ellipsis engage instead of the cell scrolling sideways.
export function PostsCalendarEntry({entry}: PropsType): JSX.Element {
    const {getLocalizedString} = useLocale();

    const moderationText = entry.moderation ? getLocalizedString(TEXT_BY_CALENDAR_MODERATION[entry.moderation]) : null;

    return (
        // Opening an entry must not also open the day drawer on the cell underneath. Usually the
        // navigation unmounts the calendar first, but not when the link is opened in a new tab.
        // No keyboard listener is missing here: activating the inner link with Enter dispatches a
        // click too, so this one handler covers both input methods.
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        <li className={styles.PostCalendar_listItem} onClick={(event) => event.stopPropagation()} title={entry.name}>
            <NavigationLink className={styles.PostCalendar_entry} to={getCalendarEntryLink(entry)}>
                <span
                    className={classNames(
                        styles.PostCalendar_dot,
                        STATUS_MODIFIER_BY_CALENDAR_POST_STATUS[entry.status]
                    )}
                />

                <FontAwesomeIcon
                    className={styles.PostCalendar_entryTypeIcon}
                    icon={ICON_BY_CALENDAR_PUBLICATION_TYPE[entry.type]}
                />

                <span className={styles.PostCalendar_entryName}>{entry.name}</span>

                {entry.moderation && moderationText ? (
                    <Tooltip title={moderationText}>
                        <FontAwesomeIcon
                            className={classNames(styles.PostCalendar_entryModeration, {
                                [styles.PostCalendar_entryModeration__rejected]:
                                    entry.moderation === CalendarModerationEnum.rejected,
                            })}
                            icon={ICON_BY_CALENDAR_MODERATION[entry.moderation]}
                        />
                    </Tooltip>
                ) : null}
            </NavigationLink>
        </li>
    );
}
